import { Button, Card, Flex, Form, Input, Layout, message, notification } from 'antd'
import MusicalBackground from '../../components/MusicalBackground'
import {
  attemptLogin,
  attemptRequestResetAdminPassword,
  AuthDTO,
} from '../../utils/redux/authSlice'
import { listenerMiddleware, useAppDispatch } from '../../utils/redux/store'
import { useWatch } from 'antd/es/form/Form'
import { useAttemptListener } from 'dev-masters-react-kit'

export default function SignIn() {
  const [signInForm] = Form.useForm<AuthDTO>()
  const dispatch = useAppDispatch()

  const email = useWatch('email', signInForm)

  function onFinish(values: AuthDTO) {
    dispatch(attemptLogin(values))
  }

  useAttemptListener({
    attempt:attemptRequestResetAdminPassword,
    listenerMiddleware,
    onFulfilled: () => {
      message.success('Super-admin will receive password reset instructions.')
      // signInForm.resetFields(['email'])
      // signInForm.setFields([
      //   {
      //     name: 'email',
      //     errors: ['If the email is registered, super-admin will receive password reset instructions.'],
      //   },
      // ])
    },
    onRejected(action, listenerApi) {
      message.error('Failed to request password reset. Please try again later.')
    },
  })

    useAttemptListener({
    listenerMiddleware: listenerMiddleware,
    attempt: attemptLogin,
    onFulfilled: (e) => {
      console.log('authorized')
    },
    onRejected: (action) => {
      notification.error({
        message: action.error.message || 'Error',
        key: action.error.message,
      })
      switch (action.error.message) {
        case 'BAD_PASSWORD':
          signInForm.setFields([
            {
              name: 'password',
              errors: ['Please check provided password'],
            },
          ])
          break
        case 'USER_NOT_FOUND':
          signInForm.setFields([
            {
              name: 'email',
              errors: ['This email is not associated with any user'],
            },
          ])
          break
      }
    },
  })
  
  async function handleRequestResetPassword() {
    try {
      // Validate only the email field
      await signInForm.validateFields(['email'])
      dispatch(attemptRequestResetAdminPassword(email || ''))
    } catch (err) {
      console.log('err:', err)
    }
  }

  return (
    <>
      <MusicalBackground />
      <Layout>
        <Flex flex={1} justify="center" align="center">
          <Card>
            <Form
              form={signInForm}
              onFinish={onFinish}
              initialValues={{
                email: process.env.REACT_APP_DEV_LOGIN,
                password: process.env.REACT_APP_DEV_PASSWORD,
                // isAdmin: true,
              }}
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: 'Please input your email!' },
                  { type: 'email', message: 'Invalid email, example: user@gmail.com!' },
                ]}
              >
                <Input placeholder="Email" />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{ required: true, message: 'Please input your password!' }]}
              >
                <Input.Password placeholder="Password" />
              </Form.Item>
              {/* <Flex justify="right">
              <Form.Item label="Admin" name="isAdmin" valuePropName="checked">
                <Checkbox />
              </Form.Item>
            </Flex> */}

              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  Log In
                </Button>
              </Form.Item>
            </Form>
            <Button type="link" size="small" block onClick={handleRequestResetPassword}>
              Reset password
            </Button>
          </Card>
        </Flex>
      </Layout>
    </>
  )
}
